import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'var(--lp-dark)',
      color: 'var(--lp-text)',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{
        fontSize: '6rem',
        fontWeight: 'bold',
        color: 'var(--lp-gold)',
        marginBottom: '20px',
        lineHeight: '1'
      }}>404</h1>
      <h2 style={{
        fontSize: '2rem',
        marginBottom: '16px',
        fontWeight: '600'
      }}>Page Not Found</h2>
      <p style={{
        color: 'var(--lp-text-dim)',
        fontSize: '1.1rem',
        marginBottom: '32px',
        maxWidth: '400px'
      }}>
        The page you are looking for doesn't exist or has been moved.
      </p>
      <Link 
        to="/" 
        style={{
          padding: '12px 24px',
          backgroundColor: 'var(--lp-gold)',
          color: 'var(--lp-black)',
          textDecoration: 'none',
          fontWeight: '600',
          borderRadius: '4px',
          transition: 'background-color 0.2s',
          fontSize: '1rem'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--lp-gold-hover)'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--lp-gold)'}
      >
        Return to Homepage
      </Link>
    </div>
  );
};

export default NotFoundPage;
